import { createAsyncThunk } from '@reduxjs/toolkit';
import { categoryService } from '../../services';

const findAllCategory = () => createAsyncThunk('category/findAll', async () => categoryService.findAll());

export default {
  findAllCategory: findAllCategory(),
};
